import { Box, styled } from '@mui/material';
import { useViewportLayout } from '~/hooks/useViewportLayout';
import { GridLayoutMode } from '~/state/atoms/viewerAtoms';
import ViewportGridLayout from './ViewportGridLayout';
import { useRegistrationHandler } from '~/hooks/registration/useRegistrationHandler';
import { useLineEraseToggleShortcut } from '~/hooks/viewer/useLineEraseToggleShortcut';
import { usePlaneSelectionShortcut } from '~/hooks/viewer/usePlaneSelectionShortcut';
import { useZoomHandler } from '~/hooks/viewer/useZoomHandler';
import { useViewportOrientationHandler } from '~/hooks/viewer/useViewportOrientationHandler';
interface ViewportLayoutContainerProps {
    mode: GridLayoutMode;
}

const ViewportLayoutContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'mode',
})<ViewportLayoutContainerProps>(({ mode }) => ({
    display: 'flex',
    height: '100%',
    ...(mode === GridLayoutMode.SideBySide
        ? { flexDirection: 'column', gap: '8px' }
        : { flexDirection: 'column' }),
}));

const Layout = () => {
    const {
        viewportLayoutContainer,
        gridLayoutMode,
        viewportOrientationOrder,
        main,
        upper,
        lower,
        secondaryMain,
        secondaryUpper,
        secondaryLower,
    } = useViewportLayout();
    useViewportOrientationHandler();
    useZoomHandler();
    useRegistrationHandler();
    usePlaneSelectionShortcut();
    useLineEraseToggleShortcut();

    return (
        <ViewportLayoutContainer
            mode={gridLayoutMode}
            ref={viewportLayoutContainer}
        >
            <ViewportGridLayout
                main={{
                    view: main.view,
                    canvas: main.canvas,
                    canvas2D: main.canvas2D,
                    orientation: viewportOrientationOrder[0],
                }}
                side={{
                    upper: {
                        view: upper.view,
                        canvas: upper.canvas,
                        canvas2D: upper.canvas2D,
                        orientation: viewportOrientationOrder[1],
                    },
                    lower: {
                        view: lower.view,
                        canvas: lower.canvas,
                        canvas2D: lower.canvas2D,
                        orientation: viewportOrientationOrder[2],
                    },
                }}
            />

            {gridLayoutMode === GridLayoutMode.SideBySide && (
                <ViewportGridLayout
                    main={{
                        view: secondaryMain.view,
                        canvas: secondaryMain.canvas,
                        canvas2D: secondaryMain.canvas2D,
                        orientation: viewportOrientationOrder[0],
                    }}
                    side={{
                        upper: {
                            view: secondaryUpper.view,
                            canvas: secondaryUpper.canvas,
                            canvas2D: secondaryUpper.canvas2D,
                            orientation: viewportOrientationOrder[1],
                        },
                        lower: {
                            view: secondaryLower.view,
                            canvas: secondaryLower.canvas,
                            canvas2D: secondaryLower.canvas2D,
                            orientation: viewportOrientationOrder[2],
                        },
                    }}
                />
            )}
        </ViewportLayoutContainer>
    );
};

export default Layout;
